// eslint-disable-next-line @typescript-eslint/no-var-requires
const manifest = require('./package.json');
const version = manifest.version;
const vueVersion = manifest.dependencies.vue.replace(/[^\d.]/g, '');
const wbDependency = manifest.dependencies['@workbench/core'];
// globals and component registry share version number
const seamlessGlobalsVersion = manifest.dependencies['@owc/component-registry-connection'].replace(
  /[^\d.]/g,
  '',
);
const versionRegex = new RegExp(/(\d+\.\d+\.\d+)/g);
const [wbVersion] = versionRegex.exec(wbDependency) || [];

module.exports = {
  APP_VERSION: version,
  VUE_VERSION: vueVersion,
  WORKBENCH_VERSION: wbVersion,
  SEAMLESS_GLOBALS_VERSION: seamlessGlobalsVersion,
};
